import { Component } from '@angular/core';
import { NgIf } from '@angular/common';
import { DEVELOPER_MODE_STRIP_TEXT, showDeveloperModeStrip } from '../../services/developer-mode-strip.util';

/** A thin strip across the top of a draft running in Developer mode, so testers know why it differs
 *  from the released app. Reads window.ZAVO_RUNTIME, which RuntimeBootstrapService sets before boot. */
@Component({
  selector: 'app-developer-mode-strip',
  standalone: true,
  imports: [NgIf],
  template: `
    <div *ngIf="visible" role="status"
         class="fixed top-0 inset-x-0 z-[95] bg-purple-600 text-white text-[11px] font-medium text-center py-1">
      {{ text }}
    </div>
  `,
})
export class DeveloperModeStripComponent {
  readonly text = DEVELOPER_MODE_STRIP_TEXT;
  readonly visible = showDeveloperModeStrip((globalThis as any).ZAVO_RUNTIME);
}
